
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/production?${queryString}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/production/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/production`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/production/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/production/${id}`, { headers: authHeader() });
    },
    updateEtapa(id, etapa) {
        return axios.patch(`${API_URL}/production/${id}/etapa`, { etapa }, { headers: authHeader() });
    },
};